module.exports = __webpack_public_path__ + "static/avatar-1fda620ca2c890998d188c289551f456.png";